export enum SkeletonLoaderTypes {
    CARD = 0,
    LINES = 1,
    SINGLE_LINE = 2,
    DOCUMENT = 3
}
